import { Allow } from '../../auth/accessToken';
import styled from 'styled-components/macro';
import { defaultRadius, distances, colors } from '../../styles/constants';
import { Link } from 'react-router-dom';
import { BankStatement, SendToPhone, Payments } from '../../components/nucleoIcons';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ListItem } from '../common';

interface NavBarProps extends WithTranslation {
    accountId: string;
}

const NavBar = (
    {
        accountId,
        t,
    }: NavBarProps
) => {
    return (
        <nav>
            <List>
                <Allow anyOfScopes={[['admin'], ['admin:checkout'], ['write:checkout']]}>
                    <ListItem>
                        <AppLink to={`/${accountId}/payments/virtual-terminal`}>
                            <ImageWrapper>
                                <SendToPhone fill="currentcolor"/>
                            </ImageWrapper>
                            <LinkText>{t('dashboard.virtual_terminal')}</LinkText>
                        </AppLink>
                    </ListItem>
                </Allow>
                <Allow anyOfScopes={[['admin'], ['admin:checkout'], ['read:checkout']]}>
                    <ListItem>
                        <AppLink to={`/${accountId}/payments`}>
                            <ImageWrapper>
                                <Payments fill="currentcolor" />
                            </ImageWrapper>
                            <LinkText>{t('dashboard.payments')}</LinkText>
                        </AppLink>
                    </ListItem>
                </Allow>
                <Allow anyOfScopes={[['admin'], ['admin:checkout'], ['write:checkout']]}>
                    <ListItem>
                        <AppLink to={`/${accountId}/reports/settlements`}>
                            <ImageWrapper>
                                <BankStatement fill="currentcolor" />
                            </ImageWrapper>
                            <LinkText>{t('dashboard.payouts')}</LinkText>
                        </AppLink>
                    </ListItem>
                </Allow>
            </List>
        </nav>
    );
};

const List = styled.ul`
    margin: 0 -${distances.tiny};
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;

    & > * {
        flex: 1;
    }

    @media (max-width: 768px) {
        margin: 0;
        gap: ${distances.tiny};
        flex-wrap: nowrap;
    }
`;
const AppLink = styled(Link)`
    padding: ${distances.large};
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${colors.primary};
    border: 2px solid transparent;
    margin: ${distances.tiny};
    text-decoration: none;
    height: 98px;
    min-width: 368px;
    flex: 1;
    border: 1px solid ${colors.borderDark};
    outline: 1px solid transparent;

    transition: all 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);

    border-radius: ${defaultRadius};
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    &:hover {
        border: 1px solid ${colors.primary};
        outline: 1px solid ${colors.primary};
        box-shadow: 0px 20px 25px -5px rgba(16, 24, 40, 0.10), 0px 8px 10px -6px rgba(16, 24, 40, 0.10);
    }

    & > img {
        margin-top: -20px;
        display: block;
    }

    @media (max-width: 768px) {
        padding: ${distances.tiny};
        min-width: auto;
        margin: 0;
        gap: 0;
        height: 80px;
    }
`;

const ImageWrapper = styled.div`
    margin-top: 16px;
    height: 40px;
    margin-bottom: ${distances.tiny};

    @media (max-width: 768px) {
        height: 30px;
        margin-top: unset;
    }
`;

const LinkText = styled.span`
    display: block;
    font-size: 18px;
    line-height: ${distances.normal};
    font-weight: 500;
    letter-spacing: -0.08px;

    @media (max-width: 768px) {
        font-size: 12px;
        margin: 0;
        word-break: break-word;
        text-align: center;
        line-height: 1;
        padding: 0 4px;
    }
`;

export default withTranslation()(NavBar);
